import { createI18nText } from '../../functions';
var genericTableText = createI18nText({
    he: {
        edit: 'עריכת',
        add: 'הוספת',
        "delete": 'מחיקת',
        ok: 'אישור',
        cancel: 'ביטול',
        addTitle: 'הוסף',
        showAll: 'הצג הכל',
        showLess: 'הצג פחות'
    },
    en: {
        edit: 'Edit',
        add: 'Add',
        "delete": 'Delete',
        ok: 'Ok',
        cancel: 'Cancel',
        addTitle: 'Add',
        showAll: 'Show all',
        showLess: 'Show less'
    }
});
export default genericTableText;
//# sourceMappingURL=genericTableText.js.map